import React, { createRef, useState, useEffect } from 'react'
import { Link } from 'gatsby'

import { Cart, Search } from '../index'

import styles from './Nav.module.sass'

const Nav = ({ sticky = false, ...rest }) => {
  const [isSticky, setIsSticky] = useState(false)
  const ref = createRef()

  // mount
  useEffect(() => {
    const cachedRef = ref.current,
      observer = new IntersectionObserver(
        ([e]) => setIsSticky(e.intersectionRatio < 1),
        { threshold: [1] }
      )

    observer.observe(cachedRef)

    // unmount
    return function () {
      observer.unobserve(cachedRef)
    }
  }, [])

  return (
    <nav
      className={styles.mainNav + (isSticky ? ' isSticky' : '')}
      ref={ref}
      {...rest}
    >
      <div className="navContainer">
        {isSticky & (rest.location === 'home') ? (
          <Link to="/">
            <h3 className={styles.logo}>Fairies of Tranquility</h3>
          </Link>
        ) : rest.location === 'main' ? (
          <Link to="/">
            <h3 className={styles.logo}>Fairies of Tranquility</h3>
          </Link>
        ) : (
          <div className={styles.navLine}></div>
        )}
        <Link to="/" activeClassName="activeNavLink">
          Home
        </Link>
        <Link to="/shop" activeClassName="activeNavLink">
          Shop
        </Link>
        <Link to="/about" activeClassName="activeNavLink">
          About Us
        </Link>
        <Link to="/contact" activeClassName="activeNavLink">
          Contact
        </Link>
        <Search />
        {isSticky ? (
          <button className="snipcart-checkout">
            <Cart />
          </button>
        ) : rest.location === 'main' ? (
          <button className="snipcart-checkout" aria-label="go to checkout">
            <Cart />
          </button>
        ) : (
          <div className={styles.navLine}></div>
        )}
      </div>
    </nav>
  )
}

export default Nav
